export const setStorage = (key, value) => localStorage.setItem(key, value);
export const getStorage = (key) => localStorage.getItem(key);
export const removeStorage = (key) => localStorage.removeItem(key);

export const setSessionStorage = (key, value) => sessionStorage.setItem(key, value);
export const getSessionStorage = (key) => sessionStorage.getItem(key);
export const removeSessionStorage = (key) => sessionStorage.removeItem(key);
